import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { Store } from "@ngrx/store";
import {
    fetchMessages,
    deleteMessage,
    addMessage,
    getMessage
} from "../../store/message/message.actions";
import { getMessageSelector, getMessagesSelector } from '@store/message/message.selectors';
import { IState } from '@models/index';
import { HelperService } from '../helper/helper.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ downline: IState }>
  ) {}

  getMessagesSelector(): Observable<IState> {
    return this.store.select(getMessagesSelector);
  }

  getMessageSelector(): Observable<IState> {
    return this.store.select(getMessageSelector);
  }

  fetchMessages(page: number, filterOptions: any, userId): void {
    this.store.dispatch(fetchMessages({ page, filterOptions, userId}));
  }

  fetchMessage(id: string) {
    this.store.dispatch(getMessage({ id }))
  }


  deleteMessage(id, to) {    
    this.store.dispatch(deleteMessage({id, to}));
  }

  addMessage(message, from) {
    this.store.dispatch(addMessage({ message, from }));
  }

  getMessages(page: number, filterOptions: any = { }, userId) {    
    const queryparams = { ...{ page }, ...filterOptions, ...userId };
    const queryString = HelperService.generateQueryParams(queryparams);
    
    return this.http.get(`${this.backendUrl}/messages?${queryString}`);
  }

  getMessage(id) {
    return this.http.get(`${this.backendUrl}/messages/message/${id}`);
  }

  removeMessage(id, to) {
    return this.http.delete(`${this.backendUrl}/messages/message/${id}`);
  }

  insertMessage(message, from) {
    return this.http.post(`${this.backendUrl}/messages/message`, message);
  }

}
